import { RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

interface RefreshButtonProps {
  onClick: () => void;
  loading: boolean;
  label?: string;
  className?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

/** Outline button with a spinning RefreshCw icon while loading. */
export function RefreshButton({
  onClick,
  loading,
  label = 'Atualizar',
  className,
  size,
}: RefreshButtonProps) {
  return (
    <Button
      variant="outline"
      size={size}
      onClick={onClick}
      disabled={loading}
      className={
        className ??
        'border-[hsl(214,32%,91%)] hover:bg-[hsl(210,40%,96%)]'
      }
    >
      <RefreshCw className={`h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
      {label}
    </Button>
  );
}
